module.exports = __webpack_public_path__ + "static/media/RaceIntroBg-sm.bb00b26d.jpg";